import { useEffect } from "react";
import { IoCloseSharp } from "react-icons/io5";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Button, Card, CardBody, Col, Row, Spinner, Table } from "reactstrap";
import notFound from "../../assets/imgs/not-found.png";
import NotesCard from "../../components/cards/NotesCard";

import SaleOrderInformations from "../../components/cards/SaleOrderInformations";
import SaleOrderTotalCard from "../../components/cards/SaleOrderTotalCard";
import AddOrderItem from "../../components/modals/AddOrderItem";
import AddReturnVendorSelection from "../../components/modals/AddReturnVendorSelection";
import AddShippingModal from "../../components/modals/AddShippingModal";
import PageName from "../../components/react_helmet/PageName";
import LogTable from "../../components/table/LogTable";
import { orderStatuses } from "../../data";
import { getStatusColor } from "../../utility";
import useReturnSaleOrder from "./customHooks/useReturnSaleOrder";
import SaleItemCard from "../../components/cards/SaleItemCard";
import OrderBillingAddressCard from "../../components/cards/OrderBillingAddressCard";
import OrderShippingAddressCard from "../../components/cards/OrderShippingAddressCard";
import SaleOrderStatuses from "../../components/cards/SaleOrderStatuses";
import { FiFileText, FiSend, FiPlus } from "react-icons/fi";
import ReactQuill from "react-quill";
import OrderDetailsSkeleton from "../../components/skeleton/OrderDetailsSkeleton";
const ReturnOrderDetails = (props) => {
    const {
        toggleItemModal,
        itemModal,
        shippingModal,
        toggleShippingModal,
        billingData,
        setBillingData,
        shippingData,
        setShippingData,
        orderStatus,
        setOrderStatus,
        totalTaxAmount,
        setTotalTaxAmount,
        subTotal,
        totalAmount,
        orderNumber,
        setOrderNumber,
        set_return_status,
        return_status,
        shipBy,
        setShipBy,
        line_items,
        setLineItems,
        note,
        setNote,
        addOrderNote,
        shippingCheckboxes,
        setShippingCheckboxes,
        handleSubmitOrder,
        poDetails,
        paymentStatus,
        setPaymentStatus,
        orderData,
        setOrderData,
        setNewLineItems,
        totalTax, order,
        creationDate, setCreationDate,
        history, checks, dataLoading,
        tm, setTm, usAddresses, selectedUSAddressId, setSelectedUSAddressId, returnOrder, orderNotes, setOrderNotes, backToSaleOrder, setUploadedLabel, setLabelsImages, labelImages, loader,
        addVendor, setAddVendor, toggleAddVendor,
    } = useReturnSaleOrder(props);

    useEffect(() => {
        console.log("Page loaded, scrolling to top");
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

        // Mark return order as seen
        if (order?.id) {
            localStorage.setItem('lastOpenedReturnOrder', order.id);
        }
    }, [order?.id]);
    if (dataLoading) {
        return (
            <div className="mt-4">
                <OrderDetailsSkeleton />
            </div>
        );
    }
    return (
        <>
            <PageName title={"Return Order Details"} />
            <>
                {
                    addVendor &&
                    <AddReturnVendorSelection
                        modal={addVendor}
                        toggle={toggleAddVendor}
                        setShippingData={setShippingData}
                    />
                }
                {itemModal &&
                    <AddOrderItem
                        toggle={toggleItemModal}
                        modal={itemModal}
                        setLineItems={setLineItems}
                        line_items={line_items}
                        orderData={orderData}
                        setOrderData={setOrderData}
                        setNewLineItems={setNewLineItems}
                    />}
                {shippingModal &&
                    <AddShippingModal
                        modal={shippingModal}
                        toggle={toggleShippingModal}
                        items={line_items}
                        shipBy={shipBy}
                        shippingData={shippingData}
                        orderData={orderData}
                        returnOrder={true}
                    />
                }
                <div className="d-flex justify-content-between align-items-center fw-bold">
                    <div className="d-flex align-items-center gap-3">
                        <h4 className="mb-0">
                            Return Order # R{order?.id}
                        </h4>
                        <div className="d-flex gap-2">
                            <div
                                style={{ backgroundColor: getStatusColor(order?.status) }}
                                className="text-center radius-15 px-3"
                            >
                                <span >
                                    {order?.return_status}
                                </span>
                            </div>
                        </div>
                    </div>
                    <ul className="list-unstyled d-flex align-items-center gap-4">
                        <li className=" pointer" onClick={backToSaleOrder}>
                            Back to Sale Order
                        </li>
                        <li className=" pointer" onClick={toggleShippingModal}>
                            Ship Return
                        </li>
                        <li className="">

                            <Button size="sm" className="bg-primary-color rounded-0" onClick={handleSubmitOrder} disabled={loader}>
                                {loader ? <Spinner size={'sm'} /> : "Save Return Order"}
                            </Button>
                        </li>
                        <li className="mx-3">
                            <IoCloseSharp
                                size={30}
                                className="pointer"
                                onClick={() => {
                                    history.goBack();
                                }}
                            />
                        </li>
                    </ul>
                </div>
                <Row className="mb-2">
                    <Col md={3}>
                        <OrderBillingAddressCard
                            title="Ship From"
                            billingData={billingData}
                            setBillingData={setBillingData}
                            shippingCheckboxes={shippingCheckboxes}
                            setShippingCheckboxes={setShippingCheckboxes}
                        />
                    </Col>
                    <Col md={3}>
                        <OrderShippingAddressCard
                            title="Ship To"
                            data={shippingData}
                            shippingCheckboxes={shippingCheckboxes}
                            setShippingCheckboxes={setShippingCheckboxes}
                            shippingData={shippingData}
                            setShippingData={setShippingData}
                            checks={checks}
                            tm={tm}
                            setTm={setTm}
                            usAddresses={usAddresses}
                            selectedUSAddressId={selectedUSAddressId}
                            setSelectedUSAddressId={setSelectedUSAddressId}
                        />
                    </Col>
                    <Col md={3}>
                        <SaleOrderInformations
                            state={orderData}
                            orderNumber={orderNumber}
                            setOrderNumber={setOrderNumber}
                            shipBy={shipBy}
                            setShipBy={setShipBy}
                            orderData={orderData}
                            creationDate={creationDate}
                            setCreationDate={setCreationDate}
                            returnOrder={returnOrder}
                        />
                    </Col>
                    <Col md={3}>
                        <SaleOrderStatuses
                            orderStatuses={orderStatuses}
                            orderStatus={orderStatus}
                            setOrderStatus={setOrderStatus}
                            return_status={return_status}
                            set_return_status={set_return_status}
                            setPaymentStatus={setPaymentStatus}
                            paymentStatus={paymentStatus}
                            orderData={orderData}
                            orderNotes={orderNotes}
                            setOrderNotes={setOrderNotes}
                        />
                    </Col>
                </Row>
                <h3>Items</h3>
                <Row>
                    {line_items?.length > 0 ? (
                        line_items?.map((item, index) => (
                            <div className="item_body_wrapper" key={item._id}>
                                <SaleItemCard
                                    index={index}
                                    data={item}
                                    line_items={line_items}
                                    setLineItems={setLineItems}
                                    poDetails={poDetails}
                                    labels={item?.labels}
                                    orderData={orderData}
                                    toggleShippingModal={toggleShippingModal}
                                    returnOrder={returnOrder}
                                />
                            </div>
                        ))
                    ) : (
                        <Card className="items__notfound rounded-0 mt-3 ">
                            <p>No Items Found </p>
                            <img src={notFound} className="notFoundImage" alt="" />
                        </Card>
                    )}
                </Row>
                <Row className="mb-4 d-flex align-items-stretch gy-4">
                    <Col md={8}>
                        <Card className="border-0 shadow-sm h-100">
                            <CardBody className="p-4 d-flex flex-column">
                                <div className="d-flex align-items-center gap-2 mb-3">
                                    <div className="bg-primary-soft p-2 rounded-circle text-primary">
                                        <FiFileText size={18} />
                                    </div>
                                    <h5 className="fw-bold text-dark mb-0 fs-16">Return Order Notes</h5>
                                </div>

                                <div className="mb-2">
                                    <ReactQuill
                                        theme="snow"
                                        value={note}
                                        placeholder="Type internal notes for this return order..."
                                        onChange={(e) => setNote(e)}
                                        style={{ height: '100px', marginBottom: '40px' }}
                                    />
                                </div>

                                <div className="d-flex justify-content-end mt-auto pt-3">
                                    <Button

                                        className="bg-primary-color px-4 rounded-2 fw-600 shadow-sm d-flex align-items-center gap-2"
                                        onClick={addOrderNote}
                                        disabled={!note}
                                        style={{ height: '42px' }}
                                    >
                                        <FiPlus size={16} />
                                        Add Note
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <div className="d-flex flex-column h-100">
                            <SaleOrderTotalCard
                                totalTaxAmount={totalTaxAmount}
                                setTotalTaxAmount={setTotalTaxAmount}
                                subTotal={subTotal}
                                totalAmount={totalAmount}
                                totalTax={totalTax}
                            />
                            <div className="mt-auto pt-3">
                                <Button

                                    className="w-100 bg-primary-color rounded-2 fw-bold text-uppercase tracking-wider shadow-sm"
                                    onClick={handleSubmitOrder}
                                    disabled={loader}
                                    style={{ height: '42px' }}
                                >
                                    {loader ? <Spinner size={'sm'} /> : "Update Return Order"}
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>

                {labelImages?.length > 0 && (
                    <Row className="mb-4">
                        <Col md={12}>
                            <div className="modern-table-container">
                                <div className="settings-card shadow-sm border-0 overflow-hidden" style={{ borderRadius: '12px' }}>
                                    <div className="bg-primary-soft p-3 border-bottom d-flex align-items-center gap-2">
                                        <h5 className="mb-0 fw-bold text-dark fs-15">Return Order Labels</h5>
                                        <span className="badge bg-white text-primary rounded-pill px-3 py-1 shadow-sm border">{labelImages?.length}</span>
                                    </div>
                                    <Table responsive hover bordered className="modern-table modern-table-sm mb-0">
                                        <thead style={{ backgroundColor: "#00509d2E" }}>
                                            <tr>
                                                <th className="align-middle">Label Name</th>
                                                <th style={{ width: "150px" }} className="text-center align-middle">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fs-14">
                                            {labelImages.map((row, index) => (
                                                <tr key={index}>
                                                    <td className="align-middle py-3">
                                                        <div className="d-flex align-items-center gap-2">
                                                            <FiFileText className="text-muted" />
                                                            <span className="fw-500">Return Label #{index + 1}</span>
                                                        </div>
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        {typeof row === "string" ? (
                                                            <a href={row} target="_blank" rel="noreferrer" className="btn btn-link btn-sm text-primary p-0">
                                                                View PDF
                                                            </a>
                                                        ) : (
                                                            <span className="text-muted italic fs-12">Pending Upload</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Col>
                    </Row>
                )}

                <LogTable orderNotes={orderNotes?.sort((a, b) => b?.createdAt - a?.createdAt)} />
            </>
        </>
    );
};
export default ReturnOrderDetails;
